import React from 'react';
import { Typography } from 'antd';
import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

// Helper function to trim long file names
const trimFileName = (fileName, maxLength = 20) => {
  if (!fileName || fileName.length <= maxLength) {
    return fileName;
  }
  
  // If it's a file with extension, preserve the extension
  const lastDotIndex = fileName.lastIndexOf('.');
  if (lastDotIndex > 0) {
    const name = fileName.substring(0, lastDotIndex);
    const extension = fileName.substring(lastDotIndex);
    const maxNameLength = maxLength - extension.length - 3; // 3 for "..."
    
    if (name.length > maxNameLength) {
      return `${name.substring(0, maxNameLength)}...${extension}`;
    }
  }
  
  // If no extension or simple truncation needed
  return `${fileName.substring(0, maxLength - 3)}...`;
};

const SourceThumb = ({ onClick, icon, label, valid = true, className = '', source }) => {
  // Support both old interface (with source prop) and new interface (with direct props)
  const displayLabel = label || (source?.getFileName ? source.getFileName() : '');
  const displayValid = valid !== undefined ? valid : (source?.isValid ? source.isValid() : true);
  
  const trimmedLabel = trimFileName(displayLabel);
  
  return (
    <div
      className={`note-sources-thumbnail-container ${className}`}
      onClick={onClick}
      style={{ cursor: 'pointer' }}
    >
      {/* Status indicator */}
      <div style={{
        position: 'absolute',
        top: '4px',
        right: '4px',
        zIndex: 1
      }}>
        {!displayValid ? (
          <ExclamationCircleOutlined 
            data-testid="close-circle"
            style={{ fontSize: 16, color: '#ff4d4f' }} 
          />
        ) : (
          <CheckCircleOutlined 
            data-testid="check-circle"
            style={{ fontSize: 16, color: '#52c41a' }}
          />
        )}
      </div>
      {icon}
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        gap: '2px', 
        width: '100%' 
      }}>
        <Text 
          style={{ 
            fontSize: '12px',
            textAlign: 'center',
            lineHeight: '1.2',
            color: '#333',
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            marginTop: '4px',
            fontWeight: 500
          }}
          title={displayLabel !== trimmedLabel ? displayLabel : undefined} // Show full name on hover if trimmed
        >
          {trimmedLabel}
        </Text>
      </div>
    </div>
  );
};

export default SourceThumb; 